export const getLocalStore = (key: string, isLocal?: boolean) => {
  if (isLocal) {
    return localStorage.getItem(key) || ''
  }
  return sessionStorage.getItem(key) || ''
}

export const setLocalStore = (
  key: string,
  value: string,
  isLocal?: boolean,
) => {
  if (isLocal) {
    localStorage.setItem(key, value)

    return
  }
  sessionStorage.setItem(key, value)
}

export const removeLocalStore = (key: string, isLocal?: boolean) => {
  if (isLocal) {
    localStorage.removeItem(key)

    return
  }
  sessionStorage.removeItem(key)
}

export const getLocalStoreParse = (key: string, isLocal?: boolean) => {
  if (isLocal) {
    const formedData = localStorage.getItem(key) || null

    if (!formedData) return null

    return JSON.parse(formedData)
  }

  const formedData = sessionStorage.getItem(key) || null

  if (!formedData) return null

  return JSON.parse(formedData)
}
